import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { addressI, Address } from 'app/core/interfaces/adress';
import { AuthService } from 'app/core/http/services/auth.service';
import { FormStateMatcher } from 'app/core/directives/form-validate';
import { DomSanitizer } from '@angular/platform-browser';
import { MapService } from 'app/core/http/services/map.service';
import { LayoutService } from 'app/core/http/services/layout.service';
import { DialogService } from 'app/services/dialog.service';
import { SecretaryInterface } from 'app/core/interfaces/secretary';
import { SecretaryService } from 'app/core/http/services/secretary.service';
import { ViaCepService } from 'app/core/http/services/viacep.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { SearchCepComponent } from 'app/modules/shared/components/map/search-cep/search-cep.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'secretary-address-form',
  templateUrl: './secretary-address-form.component.html',
  styleUrls: ['./secretary-address-form.component.scss'],
})
export class SecretaryAddressFormComponent implements OnInit {
  @Input() form: FormGroup = new FormGroup({});
  @Input() address: Address = <Address>{};
  @Input() secretary: SecretaryInterface = <SecretaryInterface>{};
  @Output() onUpdateSecretary = new EventEmitter<any>();
  @Input() mode = 'CREATE';

  public showErrorMessage = false;
  public showSuccessMessage = false;
  public loading = false;

  private secretaryId = ''; //modo create

  public childForm: FormGroup = new FormGroup({});
  readonly mapStateMatcher = new FormStateMatcher('');
  public url = '';
  public zoom = 14;

  public submittedCep = false

  public cepError = false

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private map: MapService,
    private secretaryService: SecretaryService,
    private viaCepService: ViaCepService,
    private readonly layout: LayoutService,
    private domSanitizer: DomSanitizer,
    private dialog: DialogService
  ) {
    this.childForm = this.fb.group({
      cep: new FormControl(null, [Validators.required, Validators.pattern(/^\d{5}-?\d{3}$/)]),
      number: new FormControl(null, [Validators.required]),
      country: new FormControl(null, [Validators.required]),
      city: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),
      street: new FormControl(null, [Validators.required]),
      district: new FormControl(null, [Validators.nullValidator]),
      complement: new FormControl(null, [Validators.nullValidator]),
    });
  }

  ngOnInit(): void {
    this.childForm.controls['cep'].setValue(this.address.cep);

    if (this.mode == 'CREATE') {
      this.secretaryId = this.secretary.secretaries_id;
    }

    if (this.mode == 'UPDATE' && localStorage.getItem('isFirstAccess') == 'false') {
      this.getSecretary();
    }

    this.childForm.valueChanges.subscribe(value => {
      this.onChangeForm(value);
    });
  }

  setValueToFormAddress(address?: Address) {
    if (!address) return;

    this.childForm.patchValue({
      cep: address?.cep,
      number: address?.number,
      country: address?.country,
      city: address?.city,
      state: address?.state,
      street: address?.street,
      district: address?.district,
      complement: address?.complement,
    });

    this.address = { ...this.address, ...address };
  }

  buscarCEP() {
    const config: MatDialogConfig = {
      width: '400px',
      maxWidth: '90%',
      minHeight: '200px',
    };

    this.dialog
      .openComponentDialog(
        SearchCepComponent,
        {
          param: {},
        },
        config
      )
      .subscribe((result: addressI) => {
        if (result.cep) {
          this.childForm.controls['cep'].setValue(result.cep);

          
          this.address.latitude = result.latitude;
          this.address.longitude = result.longitude;
          this.address.street = result.street;
          this.address.city = result.city;

          this.address.state = result.state;

          this.address.complement = result.complement;
          this.address.country = result.country;
          this.address.district = result.district;
        }
      });
  }

  private getSecretary() {
    const secretary_id = this.auth.getCurrentUser().user.id;

    console.log("current value", secretary_id)

    this.secretaryService.showNew(secretary_id).subscribe({
      next: (secretary: SecretaryInterface) => {
        this.secretary = secretary;
        this.setValueToFormAddress(this.secretary?.address);


        this.onUpdateSecretary.emit(secretary)
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  searchAddressByCep() {

    this.submittedCep = true
    this.cepError = false

    const cep = this.childForm.controls['cep'].value

    this.viaCepService.findByCep(cep).subscribe({
      next: (address: any) => {

        if (!address.cep) {
          this.submittedCep = false
          this.cepError = true
          return
        }

        this.childForm.patchValue({
          country: "Brasil",
          cep: address?.cep,
          number: address?.number,
          city: address?.localidade,
          state: address?.uf,
          street: address?.logradouro,
          district: address?.bairro,
          complement: address?.complement,
        });


        this.submittedCep = false

        this.onChangeForm({})
      },
      error: (err: HttpErrorResponse) => {
        this.submittedCep = false
        this.cepError = true

      },
    });
  }

  save() {
    this.showErrorMessage = false;
    this.showSuccessMessage = false;
    this.loading = true;

    const secretary_id = this.auth.getCurrentUser().user.id;
    this.secretary.address = this.childForm.value;

    const oldAddress = this.secretary?.address

    this.secretaryService.updateNew(secretary_id, this.secretary).subscribe({
      next: (secretary: SecretaryInterface) => {
        this.secretary = secretary;
        this.showErrorMessage = false;
        this.showSuccessMessage = true;
        this.loading = false;

        this.onUpdateSecretary.emit(secretary)

        if (this.objectIsEmpty(oldAddress)){

          setTimeout(() => {
              this.router.navigate(
                ['secretarias-new/meus-dados'],
                { queryParams: { tab: 'qualification' } }
              );
              this.loading = false;
          }, 500);

        }
      },
      error: (err) => {
        this.showErrorMessage = true;
        this.showSuccessMessage = false;
        this.loading = false;
      },
    });
  }

  objectIsEmpty(obj?: any): boolean {

    if (obj == null) return true;

    if (Array.isArray(obj)) {
      return obj.length === 0;
    }

    if (typeof obj === 'object') {
      const values = Object.values(obj);
      return values.every(
        v =>
          v === null ||
          v === undefined ||
          (typeof v === 'string' && v.trim() === '')
      );
    }

    return false;
  }

  getUrl() {
    this.url = `https://maps.google.com/maps?q=${this.address.latitude},${this.address.longitude}&hl=es&z=${this.zoom}&output=embed`;
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  onChangeForm(value: any) {
    this.address.cep = this.layout.getOnlyNumbers(this.childForm.get('cep')?.value).toString();
      this.address = {
      ...this.address,
      ...value,
      cep: this.layout.getOnlyNumbers(value?.cep || '')
    };
  }


  allowOnlyLetters(event: KeyboardEvent): void {
    const inputChar = event.key;

    if (!/^[a-zA-ZÀ-ÿ\s]$/.test(inputChar)) {
      event.preventDefault();
    }
  }

  markAsTouched() {
    for (var i in this.childForm.controls) {
      this.form.controls[i].markAsTouched();
    }
  }
}
